import { Room } from '@spike/room-model';
import { FunctionComponent } from 'react';
import Chip from 'components/UI/Chip';

interface Props {
    room: Room;
    small?: boolean;
    cursorPointer?: boolean;
    fullWidth?: boolean;
    className?: string;
    onDelete?: () => void;
}

export const StaffChipRoom: FunctionComponent<Props> = props => {
    return (
        <Chip
            small={props.small}
            label={props.room.name}
            className={props.className}
            onDelete={props.onDelete}
        />
    );
};

export default StaffChipRoom;
